import { Card, Modal, Input, Badge, Pagination, Radio } from "antd";
import { useEffect, useState } from "react";
import { IoSearchOutline } from "react-icons/io5";
import { Method_POST_CONTEXTO } from "../../../service/api";
import { formatCNPJ, formatDigitandoCNPJ } from "../../../function/utilis/function";

import "./style.css"
import { toast } from "react-toastify";
import Contexto from "../Modal/Tarefas/SituacaoTarefa/Contexto";
import { BsTelephoneForward } from "react-icons/bs";
import { CiShop } from "react-icons/ci";
import DadosEmpresa from "./Modal/DadosEmpresa";

const SelecaoContexto = () => {
  const [metodoBusca, setMetodoBusca] = useState("id");
  const [paramsFilter, setParamsFilter] = useState("");
  const [contexto, setContexto] = useState({});
  const [paginaAtual, setPaginaAtual] = useState(1);

  const [isListContato, setIsListContato] = useState(false);
  const [selectedIdCliente, setSelectedIdCliente] = useState(null);
  const [isDadosEmpresa, setIsDadosEmpresa] = useState(false);


  const pesquisarCliente = async (pagina = 1) => {
    const url = "/contador/cliente/pesquisar";
    const data = {
      cliente: {
        nome: paramsFilter
      },
      paginacao: {
        pagina: pagina,
        tamanho: 4
      }
    };

    if (paramsFilter === "") {
      toast.info("Por favor, digite um parâmetro de busca!");
      return;
    }

    try {
      const response = await Method_POST_CONTEXTO(url, data);

      // Normaliza os clientes
      const clientesNormalizados = response.clientes?.map(c => {
        // Se c tiver a chave 0, pega c[0], senão pega c direto
        const clienteObj = c?.[0] ?? c ?? {};
        return {
          id: clienteObj.id ?? null,
          nome: clienteObj.nome ?? "-",
          cnpj: clienteObj.cnpj ?? "",
          im: clienteObj.im ?? "",
          ie: clienteObj.ie ?? "",
          faixaFaturamento: clienteObj.faixaFaturamento ?? "",
          tipoEmpresa: clienteObj.tipoEmpresa?.id ?? "",
          enquadramento: clienteObj.enquadramento?.id ?? "",
          regimeTributario: clienteObj.regimeTributario?.id ?? "",
          segmentoEmpresa: clienteObj.segmentoEmpresa?.id ?? "",

          servico: clienteObj.servico ?? {},
          carteira: clienteObj.carteira ?? {},
          equipe: clienteObj.equipe ?? {},
          endereco: clienteObj.endereco ?? {},
        };

      }) ?? [];

      setContexto({
        ...response,
        clientes: clientesNormalizados
      });

      setPaginaAtual(pagina);
      setSelectedIdCliente(response.cliente?.id ?? null);

      return response.data;
    } catch (error) {
      console.error("Erro na requisição:", error);
      throw error;
    }
  };

  const handleChangePagina = (pagina) => {
    pesquisarCliente(pagina);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && paramsFilter.trim() !== "") {
      pesquisarCliente(1);
    }
  };

  const clienteSelecionado = contexto?.clientes?.find(c => c.id === selectedIdCliente);

  return (
    <>
      <div style={{ marginBottom: 10 }}>
        <Radio.Group
          onChange={(e) => {
            setMetodoBusca(e.target.value);
            setParamsFilter("");
          }}
          value={metodoBusca}
          name="radiogroup"
          options={[
            { value: "id", label: 'ID Cliente' },
            { value: "cnpj", label: 'CNPJ' },
            { value: "razao", label: 'Razão Social' },
            { value: "contato", label: 'Contato' },
          ]}
        >

        </Radio.Group>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>

        <div>
          {/* Input dinâmico */}
          {metodoBusca === "id" && (
            <Input
              type="text"
              value={paramsFilter}
              onChange={(e) => {
                let valor = e.target.value;

                // remove tudo que não for número
                valor = valor.replace(/[^0-9]/g, "");

                // sempre adiciona #
                valor = "#" + valor;

                setParamsFilter(valor);
              }}
              placeholder="ID do cliente"
              style={{ width: 120 }}
              onKeyDown={handleKeyDown}
            />



          )}

          {metodoBusca === "cnpj" && (
            <Input
              type="text"
              value={formatDigitandoCNPJ(paramsFilter)} // exibe formatado
              onChange={(e) => {
                // guarda apenas números (sem máscara) no state
                setParamsFilter(e.target.value.replace(/\D/g, ""));
              }}
              placeholder="Digite o CNPJ"
              style={{ width: 300 }}
              onKeyDown={handleKeyDown}
            />
          )}

          {metodoBusca === "razao" && (
            <Input
              type="text"
              value={paramsFilter}
              onChange={(e) => setParamsFilter(e.target.value)}
              placeholder="Digite a Razão Social"
              style={{ width: 500 }}
              onKeyDown={handleKeyDown}
            />
          )}

          {metodoBusca === "contato" && (
            <Input
              type="text"
              value={paramsFilter}
              onChange={(e) => setParamsFilter(e.target.value)}
              placeholder="Digite o nome do contato"
              style={{ width: 300 }}
              onKeyDown={handleKeyDown}
            />
          )}
        </div>

        <div
          className="bt-padrao-context"
          onClick={() => pesquisarCliente(1)}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 10 }}
        >
          <IoSearchOutline />
        </div>
      </div>


      <div style={{ margin: "10px 0" }}>
        <div className="table-header-context">
          <div>ID cliente</div>
          <div>C/E</div>
          <div>CNPJ</div>
          <div>Razão Social</div>
          <div style={{ textAlign: "right" }}>Acessar</div>
        </div>
        {contexto?.clientes?.map((cliente, index) => {
          const situacaoAtiva = cliente.servico?.situacao?.id === "A";

          return (
            <Badge.Ribbon
              key={index}
              text={situacaoAtiva ? "Ativa" : "Inativa"}
              color={situacaoAtiva ? "green" : "red"}
            >
              <Card title={cliente.nome} size="small" style={{ marginBottom: 16 }}>
                <div className="table-context">
                  <div><strong>{cliente.id}</strong></div>
                  <div>{cliente.carteira.id} / {cliente.equipe.id}</div>
                  <div>{formatCNPJ(cliente.cnpj)}</div>
                  <div>{cliente.nome}</div>
                  <div style={{ display: "flex" }}>
                    <div style={{ marginRight: 5 }} className="bt-contat" onClick={() => { setSelectedIdCliente(cliente.id); setIsListContato(true) }}>
                      <BsTelephoneForward />
                    </div>
                    <div className="bt-padrao-context" onClick={() => {
                      setSelectedIdCliente(cliente.id);
                      setIsDadosEmpresa(true);
                    }}>
                      <CiShop />
                    </div>
                  </div>
                </div>
              </Card>
            </Badge.Ribbon>
          );
        })}

        {/* Paginação */}
        {contexto?.paginacao?.totalPaginas > 1 && (
          <Pagination
            current={paginaAtual}
            total={contexto.paginacao.totalRegistros}
            pageSize={contexto.paginacao.tamanho}
            onChange={handleChangePagina}
            style={{ marginTop: 20, textAlign: "center" }}
          />
        )}

        <Modal
          open={isListContato}
          title="Lista de contato do cliente"
          onCancel={() => setIsListContato(false)}
          width={"55%"}>
          <Contexto selectedIdCliente={selectedIdCliente} />
        </Modal>

        <Modal
          open={isDadosEmpresa}
          title={null}
          onCancel={() => setIsDadosEmpresa(false)}
          width="600px"
          footer={null}
        >
          <DadosEmpresa clienteSelecionado={clienteSelecionado} pesquisarCliente={pesquisarCliente} />
        </Modal>

      </div>
    </>
  );
};

export default SelecaoContexto;
